'use client';

import { ReactNode } from 'react';
import useCookiebotConsent, {
  type CookiebotConsentCategory,
} from '../hooks/useCookiebotConsent';

type CookiebotConsentGuardProps = {
  children: ReactNode;
  fallback?: ReactNode;
  category?: CookiebotConsentCategory;
  enabled?: boolean;
};

const CookiebotConsentGuard = ({
  children,
  fallback = null,
  category = 'statistics',
  enabled = true,
}: CookiebotConsentGuardProps) => {
  const hasConsent = useCookiebotConsent(category, enabled);

  return hasConsent ? children : fallback;
};

export default CookiebotConsentGuard;
export type { CookiebotConsentGuardProps };
